export default "__VITE_ASSET__Dh18otm6__"